<app-common-header></app-common-header>
<div class="body">
  <div class="mainContent">
    <div class="create-module">
      <div class="create-module__sidebar">
        <div class="create-module__sidebar__courses-filter">
          <div class="create-module__sidebar__courses-filter__filter">
            <span class="create-module__sidebar__courses-filter__filter__text"
              >Filter</span
            >
            <mat-icon
              (click)="toggleCoursesFilterItems()"
              class="create-module__sidebar__courses-filter__filter__icon"
            >
              {{ showCoursesFilterItems ? "remove_circle" : "add_circle" }}
            </mat-icon>
          </div>
          <ng-container
            *ngIf="showCoursesFilterItems"
            class="create-module__sidebar__courses-filter__courses"
          >
            <div
              class="create-module__sidebar__courses-filter__courses__course"
            >
              <mat-label
                class="create-module__sidebar__courses-filter__courses__course--label"
                >Course</mat-label
              >
              <mat-select
                [(ngModel)]="selectedCourse"
                (selectionChange)="selectCourse()"
                [ngClass]="{
                  'create-module__error--border': error && selectedCourse === 0
                }"
              >
                <mat-option
                  *ngFor="let course of courses"
                  [value]="course.testTypeId"
                  >{{ course.testTypeName }}</mat-option
                >
              </mat-select>
            </div>
            <div
              class="create-module__sidebar__courses-filter__courses__course"
            >
              <mat-label
                class="create-module__sidebar__courses-filter__courses__course--label"
                >Section</mat-label
              >
              <mat-select
                [(ngModel)]="selectedSection"
                (selectionChange)="selectSection()"
                [ngClass]="{
                  'create-module__error--border': error && selectedSection === 0
                }"
              >
                <mat-option
                  *ngFor="let section of sections"
                  [value]="section.test_section_type_id"
                  >{{ section.test_section }}</mat-option
                >
              </mat-select>
            </div>

            <div
              class="create-module__sidebar__courses-filter__courses__course"
            >
              <mat-label
                class="create-module__sidebar__courses-filter__courses__course--label"
                >Topic</mat-label
              >
              <mat-select
                [(ngModel)]="selectedTopic"
                (selectionChange)="selectTopic()"
                [ngClass]="{
                  'create-module__error--border': error && selectedTopic === 0
                }"
              >
                <mat-option
                  *ngFor="let topic of topics; let topicIndex = index"
                  [value]="topic.topic_id"
                  >{{ topic.topic_name }}</mat-option
                >
              </mat-select>
            </div>
            <div
              class="create-module__sidebar__courses-filter__courses__course"
              style="padding-bottom: 10px"
            >
              <mat-label
                class="create-module__sidebar__courses-filter__courses__course--label"
                >Sub-Topic</mat-label
              >
              <mat-select
                [(ngModel)]="selectedSubTopic"
                [ngClass]="{
                  'create-module__error--border':
                    error && selectedSubTopic === 0
                }"
                (selectionChange)="selectSubTopic()"
              >
                <mat-option
                  *ngFor="let subTopic of subTopics; let subTopicIndex = index"
                  [value]="subTopic.subtopic_id"
                  >{{ subTopic.subtopic_name }}</mat-option
                >
              </mat-select>
            </div>
            <div
              class="create-module__sidebar__courses-filter__courses__course"
              style="padding-bottom: 10px"
            >
              <mat-label
                class="create-module__sidebar__courses-filter__courses__course--label"
                >Status</mat-label
              >
              <mat-select [(ngModel)]="status">
                <mat-option [value]="1">Final</mat-option>
                <mat-option [value]="0">Delete</mat-option>
                <mat-option [value]="2">Private</mat-option>
              </mat-select>
            </div>
          </ng-container>
        </div>
        <button (click)="exportToPDF()" class="create-module__sidebar__save">
          Export to PDF
        </button>
        <button
          (click)="saveLearningModule()"
          class="create-module__sidebar__save"
          [disabled]="saveClicked"
        >
          Save
        </button>
        <div class="create-module__sidebar__panel">
          <div class="create-module__sidebar__panel__filter">
            <span class="create-module__sidebar__panel__filter__text"
              >Panel</span
            >
            <mat-icon
              (click)="togglePanelItems()"
              class="create-module__sidebar__panel__filter__icon"
            >
              {{ showPanelItems ? "remove_circle" : "add_circle" }}
            </mat-icon>
          </div>
          <div
            class="create-module__sidebar__panel__items"
            *ngIf="showPanelItems"
            cdkDropList
            (cdkDropListDropped)="drop($event)"
          >
            <span
              cdkDrag
              *ngFor="let data of editorArray; let index = index"
              class="create-module__sidebar__panel__items__title"
              ><mat-icon>{{ data.panelType.icon }}</mat-icon>
              {{ data.title }}</span
            >
          </div>
          <span
            *ngIf="showPanelItems"
            class="create-module__sidebar__panel__add-btn"
            (click)="toggleOverlay(overlay, $event, -1, 'panel', 'panel')"
          >
            <mat-icon style="color: #4eaeeb">add</mat-icon>
            <span style="color: #4eaeeb">Add Panel</span>
          </span>
        </div>
        <!-- <button class="create-module__sidebar__add-btn" (click)="addPanel()">
          Add Panel
        </button> -->
      </div>
      <div class="create-module__right" [class.blur]="loading">
        <div *ngIf="loading" class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
        <div class="create-module__right__editor">
          <div
            *ngFor="let data of editorArray; let index = index"
            class="create-module__right__editor__box"
            [ngClass]="{
              'create-module__error--box-border':
                (error &&
                  ((data.title === '' &&
                    data.panelType.display !== 'General') ||
                    ((data.panelType.display ===
                      'Exercise (From Question Bank)' ||
                      data.panelType.type === 'quiz') &&
                      data.questions.length === 0))) ||
                (data.panelType.type !== 'quiz' &&
                  data.panelType.type !== 'overview' &&
                  data.panelType.type !== 'tip' &&
                  !data.panelType.display.includes('Exercise') &&
                  data.content.length === 0)
            }"
          >
            <span class="create-module__right__editor__box__head__input-title">
              <input
                class="create-module__right__editor__box__head__input-title"
                [(ngModel)]="data.title"
                placeholder="Title"
                value="Title"
              />
              <span class="create-module__right__editor__box__head__cross">
                <mat-icon (click)="toggleAccordion(index, editorArray)">{{
                  !data.hidden ? "arrow_drop_up" : "arrow_drop_down"
                }}</mat-icon>
                <img
                  (click)="confirmDelete(index, 'panel', -1)"
                  src="assets/crossbutton.png"
                />
              </span>
            </span>
            <div class="flex" *ngIf="!data.hidden">
              <span
                *ngIf="
                  data.panelType.type === 'quiz' ||
                  data.panelType.display.includes('Exercise')
                "
                class="create-module__right__editor__box__add"
                (click)="
                  toggleOverlay(
                    overlay,
                    $event,
                    index,
                    panelStrings.ADDITIONAL,
                    data.panelType.display
                  )
                "
              >
                <mat-icon style="color: #4eaeeb">add</mat-icon>
                <span style="color: #4eaeeb">Add</span>
              </span>
              <span
                class="create-module__right__editor__box__add"
                [ngClass]="{
                  'create-module__right__editor__box__add--question':
                    data.panelType.type === 'quiz' ||
                    data.panelType.display.includes('Exercise')
                }"
                (click)="
                  toggleOverlay(
                    overlay,
                    $event,
                    index,
                    'code',
                    data.panelType.display
                  )
                "
              >
                <mat-icon style="color: #4eaeeb">add</mat-icon>
                <span style="color: #4eaeeb"
                  >Add{{
                    data.panelType.type === "quiz" ||
                    data.panelType.display.includes("Exercise")
                      ? "Question"
                      : ""
                  }}</span
                >
              </span>
            </div>
            <!-- <span *ngFor="let data of editorBodyArray">
              <textarea
                *ngIf="showTextArea"
                style="
                  height: 8rem;
                  border: none;
                  width: -webkit-fill-available;
                  border: 1px solid darkgray;
                  border-radius: 8px;
                  padding: 8px;
                "
                [(ngModel)]="data.content.data"
                placeholder="Body"
                value="Body"
              ></textarea>
            </span> -->
            <ng-container *ngIf="!data.hidden">
              <input
                *ngIf="data.panelType.type === 'tip'"
                placeholder="subtitle"
                [(ngModel)]="data.subTitle"
                class="create-module__create-box__body__input"
              />
              <ng-container
                *ngIf="
                  !data.panelType.display.includes('Exercise') &&
                  data.content[0]?.type !== 'Empty'
                "
              >
                <div
                  *ngFor="let editData of data.content; let editIndex = index"
                  class="create-module__create-box__body__textarea-box"
                  [ngClass]="{
                    'create-module__error--box-border':
                      error &&
                      editData.images.length === 0 &&
                      editData.videos?.length === 0 &&
                      editData.data === '',
                    'd-none': editData.type === 'subtitle'
                  }"
                >
                  <app-mathjax-editor
                    *ngIf="
                      editorTypes.MathJax === editData.type && !editData.hidden
                    "
                    [mathjaxTextarea]="textArea"
                    (updateValue)="updateMathjaxValue($event, editData)"
                  ></app-mathjax-editor>
                  <div
                    class="create-module__create-box__body__textarea-box__head"
                  >
                    <span
                      (click)="toggleAccordion(editIndex, data.content)"
                      class="create-module__create-box__body__textarea-box__head__type"
                      >{{ editData.type }}
                      <mat-icon>{{
                        data.hidden ? "arrow_drop_up" : "arrow_drop_down"
                      }}</mat-icon></span
                    >
                    <img
                      (click)="confirmDelete(editIndex, 'code', index)"
                      src="assets/crossbutton.png"
                      class="create-module__create-box__body__textarea-box__head__icon"
                    />
                  </div>
                  <textarea
                    class="create-module__create-box__body__textarea-box__textarea"
                    [ngClass]="{
                      'create-module__create-box__body__textarea-box__textarea--hidden':
                        editData.hidden ||
                        editData.type === 'Images' ||
                        editData.type === 'Videos',
                      'create-module__create-box__body__textarea-box__textarea--mathjax':
                        editorTypes.MathJax === editData.type
                    }"
                    [(ngModel)]="editData.data"
                    [id]="'question-' + index"
                    #textArea
                  ></textarea>
                  <div
                    *ngIf="!editData.hidden && editData.type === 'Images'"
                    class="create-module__right__editor__selectFiles-container"
                  >
                    <button
                      (click)="file.click()"
                      class="create-module__right__editor__selectFiles-container__button"
                    >
                      Select Files
                    </button>
                    <input
                      #file
                      type="file"
                      accept="image/*"
                      [id]="'panel-' + editIndex + '-' + index"
                      (change)="
                        uploadFile($event, file, index, editIndex, null)
                      "
                      class="create-module__right__editor__file"
                    />
                    <div class="create-module__questions">
                      <div
                        *ngFor="
                          let image of editData.images;
                          let imageIndex = index
                        "
                        class="create-module__questions__question"
                      >
                        <!-- <mat-icon
                          class="create-module__questions__question__close"
                          (click)="removeQuestion(index, questionIndex)"
                          >cancel</mat-icon
                        > -->
                        {{ "Image " }}{{ imageIndex + 1 }}
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="!editData.hidden && editData.type === 'Videos'"
                    class="create-module__right__editor__selectFiles-container create-module__right__editor__selectFiles-container__video-container"
                  >
                    <input
                      type="file"
                      multiple
                      hidden
                      accept="video/*"
                      #videoInput
                      (change)="onVideoSelect($event, editData, videoInput)"
                    />

                    <div
                      class="create-module__right__editor__selectFiles-container__video-container__video-actions"
                    >
                      <button
                        class="create-module__right__editor__selectFiles-container__video-container__video-actions__upload-btn"
                        [disabled]="
                          !(moduleId && editData.selectedVideos?.length)
                        "
                        (click)="uploadVideos(editData)"
                      >
                        Upload Videos
                      </button>
                      <button
                        class="create-module__right__editor__selectFiles-container__video-container__video-actions__select-btn"
                        (click)="videoInput.click()"
                      >
                        Select Videos
                      </button>
                    </div>
                    <div
                      class="create-module__right__editor__selectFiles-container__video-container__selected-files"
                      *ngIf="editData.selectedVideos?.length"
                    >
                      <p *ngFor="let file of editData.selectedVideos">
                        {{ file.name }}
                      </p>
                    </div>

                    <div
                      *ngIf="editData.isUploading"
                      class="create-module__right__editor__selectFiles-container__video-container__upload-progress"
                    >
                      <p>Uploading videos... {{ editData.uploadProgress }}%</p>
                      <div
                        class="create-module__right__editor__selectFiles-container__video-container__upload-progress__progress-bar-container"
                      >
                        <div
                          class="create-module__right__editor__selectFiles-container__video-container__upload-progress__progress-bar-fill"
                          [style.width.%]="editData.uploadProgress"
                        ></div>
                      </div>
                    </div>

                    <div
                      *ngIf="editData.videos?.length"
                      class="create-module__right__editor__selectFiles-container__video-container__uploaded-list"
                    >
                      <div
                        cdkDropList
                        [cdkDropListData]="editData.videos"
                        (cdkDropListDropped)="
                          dragAndDropVideo($event, editData)
                        "
                        class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container"
                      >
                        <div
                          class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item"
                          *ngFor="let video of editData.videos; let i = index"
                          cdkDrag
                        >
                          <div
                            class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left"
                          >
                            <div
                              class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-top-line"
                            >
                              <div
                                class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-top-line__video-name"
                              >
                                {{ videoMap.get(video.videoId)?.videoName }}
                              </div>
                              <label
                                class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-top-line__switch"
                              >
                                <input
                                  type="checkbox"
                                  [ngModel]="
                                    videoMap.get(video.videoId)?.isActive
                                  "
                                  (ngModelChange)="
                                    toggleVideoStatus(video.videoId!, $event)
                                  "
                                />
                                <span class="slider"></span>
                              </label>
                            </div>

                            <div
                              class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-date"
                            >
                              {{
                                videoMap.get(video.videoId)?.createdOn
                                  | date: "MM-dd-yyyy hh:mm a"
                              }}
                            </div>

                            <div
                              class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-uploaded-by"
                            >
                              {{ videoMap.get(video.videoId)?.uploadedBy }}
                            </div>
                          </div>

                          <div
                            class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-right"
                          >
                            <ng-container
                              *ngIf="video.isEditorActive; else playBtn"
                            >
                              <span
                                class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-right__video-close-btn"
                                (click)="video.isActive = false"
                                >X</span
                              >
                              <iframe
                                [src]="
                                  videoMap.get(video.videoId)?.safeBunnyUrl
                                "
                                width="70%"
                                height="300"
                                frameborder="0"
                                allowfullscreen
                                allow="autoplay; fullscreen; picture-in-picture"
                              ></iframe>
                            </ng-container>

                            <ng-template #playBtn>
                              <button (click)="video.isEditorActive = true">
                                Play
                              </button>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container
                *ngIf="
                  (data.panelType.display.includes('Exercise') ||
                    data.panelType.type === 'quiz') &&
                  data.additionalInfo
                "
              >
                <div
                  *ngFor="
                    let editData of data.additionalInfo;
                    let editIndex = index
                  "
                  class="create-module__create-box__body__textarea-box"
                  [ngClass]="{
                    'create-module__error--box-border':
                      error &&
                      editData.images.length === 0 &&
                      editData.videos?.length === 0 &&
                      editData.data === ''
                  }"
                >
                  <app-mathjax-editor
                    *ngIf="
                      editorTypes.MathJax === editData.type && !editData.hidden
                    "
                    [mathjaxTextarea]="textArea"
                    (updateValue)="updateMathjaxValue($event, editData)"
                  ></app-mathjax-editor>
                  <div
                    class="create-module__create-box__body__textarea-box__head"
                  >
                    <span
                      (click)="toggleAccordion(editIndex, data.additionalInfo)"
                      class="create-module__create-box__body__textarea-box__head__type"
                      >{{ editData.type }}
                      <mat-icon>{{
                        data.hidden ? "arrow_drop_up" : "arrow_drop_down"
                      }}</mat-icon></span
                    >
                    <img
                      (click)="
                        confirmDelete(editIndex, panelStrings.ADDITIONAL, index)
                      "
                      src="assets/crossbutton.png"
                      class="create-moudle__create-box__body__textarea-box__head__icon"
                    />
                  </div>
                  <textarea
                    class="create-module__create-box__body__textarea-box__textarea"
                    [ngClass]="{
                      'create-module__create-box__body__textarea-box__textarea--hidden':
                        editData.hidden ||
                        editData.type === 'Images' ||
                        editData.type === 'Videos',
                      'create-module__create-box__body__textarea-box__textarea--mathjax':
                        editorTypes.MathJax === editData.type
                    }"
                    [(ngModel)]="editData.data"
                    [id]="'question-' + index"
                    #textArea
                  ></textarea>
                  <div
                    *ngIf="!editData.hidden && editData.type === 'Images'"
                    class="create-module__right__editor__selectFiles-container"
                  >
                    <button
                      (click)="file.click()"
                      class="create-module__right__editor__selectFiles-container__button"
                    >
                      Select Files
                    </button>
                    <input
                      #file
                      type="file"
                      accept="image/*"
                      [id]="'panel-' + editIndex + '-' + index"
                      (change)="
                        uploadFile($event, file, index, editIndex, null)
                      "
                      class="create-module__right__editor__file"
                    />
                    <div class="create-module__questions">
                      <div
                        *ngFor="
                          let image of editData.images;
                          let imageIndex = index
                        "
                        class="create-module__questions__question"
                      >
                        <!-- <mat-icon
                          class="create-module__questions__question__close"
                          (click)="removeQuestion(index, questionIndex)"
                          >cancel</mat-icon
                        > -->
                        {{ "Image " }}{{ imageIndex + 1 }}
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="!editData.hidden && editData.type === 'Videos'"
                    class="create-module__right__editor__selectFiles-container create-module__right__editor__selectFiles-container__video-container"
                  >
                    <input
                      type="file"
                      multiple
                      hidden
                      accept="video/*"
                      #videoInput
                      (change)="onVideoSelect($event, editData, videoInput)"
                    />

                    <div
                      class="create-module__right__editor__selectFiles-container__video-container__video-actions"
                    >
                      <button
                        class="create-module__right__editor__selectFiles-container__video-container__video-actions__upload-btn"
                        [disabled]="
                          !(moduleId && editData.selectedVideos?.length)
                        "
                        (click)="uploadVideos(editData)"
                      >
                        Upload Videos
                      </button>
                      <button
                        class="create-module__right__editor__selectFiles-container__video-container__video-actions__select-btn"
                        (click)="videoInput.click()"
                      >
                        Select Videos
                      </button>
                    </div>
                    <div
                      class="create-module__right__editor__selectFiles-container__video-container__selected-files"
                      *ngIf="editData.selectedVideos?.length"
                    >
                      <p *ngFor="let file of editData.selectedVideos">
                        {{ file.name }}
                      </p>
                    </div>

                    <div
                      *ngIf="editData.isUploading"
                      class="create-module__right__editor__selectFiles-container__video-container__upload-progress"
                    >
                      <p>Uploading videos... {{ editData.uploadProgress }}%</p>
                      <div
                        class="create-module__right__editor__selectFiles-container__video-container__upload-progress__progress-bar-container"
                      >
                        <div
                          class="create-module__right__editor__selectFiles-container__video-container__upload-progress__progress-bar-fill"
                          [style.width.%]="editData.uploadProgress"
                        ></div>
                      </div>
                    </div>

                    <div
                      *ngIf="editData.videos?.length"
                      class="create-module__right__editor__selectFiles-container__video-container__uploaded-list"
                    >
                      <div
                        cdkDropList
                        [cdkDropListData]="editData.videos"
                        (cdkDropListDropped)="
                          dragAndDropVideo($event, editData)
                        "
                        class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container"
                      >
                        <div
                          class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item"
                          *ngFor="let video of editData.videos; let i = index"
                          cdkDrag
                        >
                          <div
                            class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left"
                          >
                            <div
                              class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-top-line"
                            >
                              <div
                                class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-top-line__video-name"
                              >
                                {{ videoMap.get(video.videoId)?.videoName }}
                              </div>
                              <label
                                class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-top-line__switch"
                              >
                                <input
                                  type="checkbox"
                                  [ngModel]="
                                    videoMap.get(video.videoId)?.isActive
                                  "
                                  (ngModelChange)="
                                    toggleVideoStatus(video.videoId!, $event)
                                  "
                                />
                                <span class="slider"></span>
                              </label>
                            </div>

                            <div
                              class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-date"
                            >
                              {{
                                videoMap.get(video.videoId)?.createdOn
                                  | date: "MM-dd-yyyy hh:mm a"
                              }}
                            </div>

                            <div
                              class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-uploaded-by"
                            >
                              {{ videoMap.get(video.videoId)?.uploadedBy }}
                            </div>
                          </div>

                          <div
                            class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-right"
                          >
                            <ng-container
                              *ngIf="video.isEditorActive; else playBtn"
                            >
                              <span
                                class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-right__video-close-btn"
                                (click)="video.isActive = false"
                                >X</span
                              >
                              <iframe
                                [src]="
                                  videoMap.get(video.videoId)?.safeBunnyUrl
                                "
                                width="70%"
                                height="300"
                                frameborder="0"
                                allowfullscreen
                                allow="autoplay; fullscreen; picture-in-picture"
                              ></iframe>
                            </ng-container>

                            <ng-template #playBtn>
                              <button (click)="video.isEditorActive = true">
                                Play
                              </button>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container
                *ngIf="
                  (data.panelType.display.includes(
                    'Exercise (From Question Bank)'
                  ) ||
                    data.panelType.type === 'quiz') &&
                  data.questions!.length > 0
                "
              >
                <div>
                  You've selected the following questions from question bank
                </div>
                <div class="create-module__questions" cdkDropListGroup>
                  <div
                    *ngFor="
                      let question of data.questions;
                      let questionIndex = index
                    "
                    cdkDropList
                    [cdkDropListData]="questionIndex"
                  >
                    <div
                      class="create-module__questions__question"
                      cdkDrag
                      [cdkDragData]="questionIndex"
                      (cdkDragEntered)="dropQuestion($event, data.questions)"
                    >
                      <mat-icon
                        class="create-module__questions__question__close"
                        (click)="removeQuestion(index, questionIndex)"
                        >cancel</mat-icon
                      >
                      {{ question?.question?.questionId }}
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container
                *ngIf="
                  data.panelType.display.includes(
                    'Exercise (Enter Manually)'
                  ) && data.questions!.length > 0
                "
              >
                <div
                  class="create-module__manual-question"
                  *ngFor="
                    let question of data.questions;
                    let questionIndex = index
                  "
                >
                  <div
                    class="create-module__create-box__body__textarea-box__head create-module__manual-question__head"
                  >
                    <span
                      (click)="toggleAccordion(questionIndex, data.questions!)"
                      class="create-module__create-box__body__textarea-box__head__type"
                      >Question{{ questionIndex + 1 }}
                      <mat-icon>{{
                        data.hidden ? "arrow_drop_up" : "arrow_drop_down"
                      }}</mat-icon></span
                    >
                    <img
                      (click)="confirmDelete(questionIndex, 'question', index)"
                      src="assets/crossbutton.png"
                      class="create-module__create-box__body__textarea-box__head__icon create-module__manual-question__head__icon"
                    />
                  </div>
                  <ng-container *ngIf="!question.hidden">
                    <span
                      *ngIf="!data.hidden"
                      class="create-module__right__editor__box__add"
                      (click)="
                        toggleOverlay(
                          overlay,
                          $event,
                          index,
                          'question',
                          data.panelType.display,
                          questionIndex
                        )
                      "
                    >
                      <mat-icon style="color: #4eaeeb">add</mat-icon>
                      <span style="color: #4eaeeb">Add</span>
                    </span>
                    <div
                      *ngFor="
                        let editData of question.question;
                        let editIndex = index
                      "
                      class="create-module__create-box__body__textarea-box"
                      [ngClass]="{
                        'create-module__error--box-border':
                          error &&
                          editData.images.length === 0 &&
                          editData.videos?.length === 0 &&
                          editData.data === ''
                      }"
                    >
                      <app-mathjax-editor
                        *ngIf="
                          editorTypes.MathJax === editData.type &&
                          !editData.hidden
                        "
                        [mathjaxTextarea]="textArea"
                        (updateValue)="updateMathjaxValue($event, editData)"
                      ></app-mathjax-editor>
                      <div
                        class="create-module__create-box__body__textarea-box__head"
                      >
                        <span
                          (click)="
                            toggleAccordion(editIndex, question.question)
                          "
                          class="create-module__create-box__body__textarea-box__head__type"
                          >{{ editData.type }}
                          <mat-icon>{{
                            data.hidden ? "arrow_drop_up" : "arrow_drop_down"
                          }}</mat-icon></span
                        >
                        <img
                          (click)="
                            confirmDelete(
                              editIndex,
                              'code-question',
                              index,
                              questionIndex
                            )
                          "
                          src="assets/crossbutton.png"
                          class="create-module__create-box__body__textarea-box__head__icon"
                        />
                      </div>
                      <textarea
                        class="create-module__create-box__body__textarea-box__textarea"
                        [ngClass]="{
                          'create-module__create-box__body__textarea-box__textarea--hidden':
                            editData.hidden ||
                            editData.type === 'Images' ||
                            editData.type === 'Videos',
                          'create-module__create-box__body__textarea-box__textarea--mathjax':
                            editorTypes.MathJax === editData.type
                        }"
                        [(ngModel)]="editData.data"
                        [id]="'question-' + index"
                        #textArea
                      ></textarea>
                      <div
                        *ngIf="!editData.hidden && editData.type === 'Images'"
                        class="create-module__right__editor__selectFiles-container"
                      >
                        <button
                          (click)="questionFile.click()"
                          class="create-module__right__editor__selectFiles-container__button"
                        >
                          Select Files
                        </button>
                        <input
                          #questionFile
                          type="file"
                          accept="image/*"
                          (change)="
                            uploadFile(
                              $event,
                              questionFile,
                              index,
                              questionIndex,
                              editIndex
                            )
                          "
                          class="create-module__right__editor__file"
                        />
                        <div class="create-module__questions">
                          <div
                            *ngFor="
                              let image of editData.images;
                              let imageIndex = index
                            "
                            class="create-module__questions__question"
                          >
                            <!-- <mat-icon
                              class="create-module__questions__question__close"
                              (click)="removeQuestion(index, questionIndex)"
                              >cancel</mat-icon
                            > -->
                            {{ "Image " }}{{ imageIndex + 1 }}
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="!editData.hidden && editData.type === 'Videos'"
                        class="create-module__right__editor__selectFiles-container create-module__right__editor__selectFiles-container__video-container"
                      >
                        <input
                          type="file"
                          multiple
                          hidden
                          accept="video/*"
                          #videoInput
                          (change)="onVideoSelect($event, editData, videoInput)"
                        />

                        <div
                          class="create-module__right__editor__selectFiles-container__video-container__video-actions"
                        >
                          <button
                            class="create-module__right__editor__selectFiles-container__video-container__video-actions__upload-btn"
                            [disabled]="
                              !(moduleId && editData.selectedVideos?.length)
                            "
                            (click)="uploadVideos(editData)"
                          >
                            Upload Videos
                          </button>
                          <button
                            class="create-module__right__editor__selectFiles-container__video-container__video-actions__select-btn"
                            (click)="videoInput.click()"
                          >
                            Select Videos
                          </button>
                        </div>
                        <div
                          class="create-module__right__editor__selectFiles-container__video-container__selected-files"
                          *ngIf="editData.selectedVideos?.length"
                        >
                          <p *ngFor="let file of editData.selectedVideos">
                            {{ file.name }}
                          </p>
                        </div>

                        <div
                          *ngIf="editData.isUploading"
                          class="create-module__right__editor__selectFiles-container__video-container__upload-progress"
                        >
                          <p>
                            Uploading videos... {{ editData.uploadProgress }}%
                          </p>
                          <div
                            class="create-module__right__editor__selectFiles-container__video-container__upload-progress__progress-bar-container"
                          >
                            <div
                              class="create-module__right__editor__selectFiles-container__video-container__upload-progress__progress-bar-fill"
                              [style.width.%]="editData.uploadProgress"
                            ></div>
                          </div>
                        </div>

                        <div
                          *ngIf="editData.videos?.length"
                          class="create-module__right__editor__selectFiles-container__video-container__uploaded-list"
                        >
                          <div
                            cdkDropList
                            [cdkDropListData]="editData.videos"
                            (cdkDropListDropped)="
                              dragAndDropVideo($event, editData)
                            "
                            class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container"
                          >
                            <div
                              class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item"
                              *ngFor="
                                let video of editData.videos;
                                let i = index
                              "
                              cdkDrag
                            >
                              <div
                                class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left"
                              >
                                <div
                                  class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-top-line"
                                >
                                  <div
                                    class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-top-line__video-name"
                                  >
                                    {{ videoMap.get(video.videoId)?.videoName }}
                                  </div>
                                  <label
                                    class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-top-line__switch"
                                  >
                                    <input
                                      type="checkbox"
                                      [ngModel]="
                                        videoMap.get(video.videoId)?.isActive
                                      "
                                      (ngModelChange)="
                                        toggleVideoStatus(
                                          video.videoId!,
                                          $event
                                        )
                                      "
                                    />
                                    <span class="slider"></span>
                                  </label>
                                </div>

                                <div
                                  class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-date"
                                >
                                  {{
                                    videoMap.get(video.videoId)?.createdOn
                                      | date: "MM-dd-yyyy hh:mm a"
                                  }}
                                </div>

                                <div
                                  class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-left__video-uploaded-by"
                                >
                                  {{ videoMap.get(video.videoId)?.uploadedBy }}
                                </div>
                              </div>

                              <div
                                class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-right"
                              >
                                <ng-container
                                  *ngIf="video.isEditorActive; else playBtn"
                                >
                                  <span
                                    class="create-module__right__editor__selectFiles-container__video-container__uploaded-list__video-drop-container__attached-video-item__attached-video-right__video-close-btn"
                                    (click)="video.isActive = false"
                                    >X</span
                                  >
                                  <iframe
                                    [src]="
                                      videoMap.get(video.videoId)?.safeBunnyUrl
                                    "
                                    width="70%"
                                    height="300"
                                    frameborder="0"
                                    allowfullscreen
                                    allow="
                                      autoplay;
                                      fullscreen;
                                      picture-in-picture;
                                    "
                                  ></iframe>
                                </ng-container>

                                <ng-template #playBtn>
                                  <button (click)="video.isEditorActive = true">
                                    Play
                                  </button>
                                </ng-template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="create-module__create-box__body__textarea-box"
                      [ngClass]="{
                        'create-module__error--box-border':
                          error && question.answer.data === ''
                      }"
                    >
                      <app-mathjax-editor
                        *ngIf="!question.answer.hidden"
                        [mathjaxTextarea]="textArea"
                        (updateValue)="
                          updateMathjaxValue($event, question.answer)
                        "
                      ></app-mathjax-editor>
                      <div
                        class="create-module__create-box__body__textarea-box__head"
                      >
                        <span
                          (click)="
                            question.answer.hidden = !question.answer.hidden
                          "
                          class="create-module__create-box__body__textarea-box__head__type"
                          >Answer
                          <mat-icon>{{
                            data.hidden ? "arrow_drop_up" : "arrow_drop_down"
                          }}</mat-icon></span
                        >
                      </div>
                      <textarea
                        class="create-module__create-box__body__textarea-box__textarea create-module__create-box__body__textarea-box__textarea--mathjax"
                        [ngClass]="{
                          'create-module__create-box__body__textarea-box__textarea--hidden':
                            question.answer.hidden
                        }"
                        [(ngModel)]="question.answer.data"
                        [id]="'question-' + index"
                        #textArea
                      ></textarea>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <div class="create-module__right__preview">
          <span
            (click)="previewLoadTikZ()"
            class="create-module__right__preview__tikz"
            >Preview Tikz Images</span
          >
          <div
            *ngFor="let data of editorArray; let index = index"
            class="create-module__right__preview__content"
          >
            <span
              *ngIf="data.panelType.display === 'Overview'"
              class="create-module__right__preview__content__title"
              [mathjax]="data.title"
            ></span>
            <!-- <span
              *ngIf="data.panelType.display === 'Tip'"
              class="create-module__right__preview__content__secondary-title"
              [mathjax]="data.title"
            ></span>
            <span
              *ngIf="data.panelType.display === 'Example'"
              class="create-module__right__preview__content__secondary-title"
              [mathjax]="data.title"
            ></span>
            <span
              *ngIf="
                data.panelType.display !== 'Overview' &&
                data.panelType.display !== 'Tip' &&
                data.panelType.display !== 'Example' &&
                data.panelType.display !== 'General'
              "
              class="create-module__right__preview__content__secondary-title"
              [mathjax]="data.title"
            ></span> -->
            <span
              *ngIf="
                (data.panelType.display !== 'General' &&
                  data.panelType.display !== 'Overview') ||
                (data.panelType.display === 'General' &&
                  data.title !== 'General')
              "
              class="create-module__right__preview__content__secondary-title learning-modules-container__mainContent__highlight"
              [ngClass]="{
                'learning-modules-container__mainContent__highlight__tip':
                  data.panelType.display === 'Tip',
                'learning-modules-container__mainContent__highlight__example':
                  data.panelType.display === 'Example',
                'learning-modules-container__mainContent__highlight__exercise':
                  data.panelType.display.includes('Exercise'),
                'learning-modules-container__mainContent__highlight__key-take-aways':
                  data.panelType.display === 'Key takeaways',
                'learning-modules-container__mainContent__highlight__general':
                  data.panelType.display === 'General',
                'learning-modules-container__mainContent__highlight__quiz':
                  data.panelType.display === 'Quiz'
              }"
            >
              <span [mathjax]="data.title"></span>
              <span
                class="create-module__right__preview__content__secondary-title--normal"
                *ngIf="data.panelType.type === 'tip' && data.subTitle !== ''"
                [mathjax]="' - ' + data.subTitle"
              ></span>
            </span>
            <ng-container
              *ngIf="
                (data.panelType.display.includes('Exercise') ||
                  data.panelType.type === 'quiz') &&
                data.additionalInfo
              "
            >
              <span
                *ngFor="
                  let editData of data.additionalInfo;
                  let editIndex = index
                "
                class="learning-modules-container__pt-20"
              >
                <app-multi-data
                  [multiData]="{
                    type: editData.type,
                    data: editData.data,
                    tikzId:
                      'learningModule-tikz-additional-' +
                      editIndex +
                      '-' +
                      index,
                    imageKeys: editData.images || [],
                    listOfImages: images,
                    videos: editData.videos || [],
                    videoMap: videoMap
                  }"
                  *ngIf="editData.type !== 'Images'"
                ></app-multi-data>
                <ng-container *ngIf="editData.type === 'Images'">
                  <img
                    *ngFor="let image of editData.images"
                    [src]="images[image]"
                    class="create-module__right__preview__image"
                  />
                </ng-container>
              </span>
            </ng-container>
            <div
              *ngIf="
                (data.panelType.display === 'Exercise (From Question Bank)' ||
                  data.panelType.display === 'Quiz') &&
                data.questions!.length !== 0
              "
              class="create-module__question-container"
            >
              <ng-container
                *ngFor="
                  let question of data.questions;
                  let questionIndex = index
                "
              >
                <div
                  *ngIf="question"
                  class="create-module__right__preview__body"
                >
                  <div
                    class="create-module__right__preview__body__item"
                    [ngClass]="{
                      'create-module__right__preview__body__item--grid':
                        question.question.displayStyle === 2
                    }"
                  >
                    <span
                      class="learning-modules-container__mt-20 create-module__right__preview__question create-module__right__preview__body__item--title"
                      >Question {{ questionIndex + 1 }}</span
                    >
                    <div>
                      <div
                        class="create-module__right__preview__body__item__item"
                      >
                        <!-- <span class="create-module__dialog__body__item__item--title"
                      >Question {{ questionIndex + 1 }}</span
                    > -->
                        <div
                          *ngFor="
                            let content of question.question.questionData;
                            let questionDataIndex = index
                          "
                          [ngClass]="{
                            'create-module__right__preview__body__item__item--tikz':
                              content.type === 'TikZ'
                          }"
                        >
                          <app-multi-data
                            [multiData]="{
                              type: content.type,
                              data: content.data,
                              tikzId:
                                'learningModule-tikz-' +
                                questionDataIndex +
                                '-' +
                                questionIndex +
                                '-' +
                                index,
                              imageKeys: content.images,
                              listOfImages: images,
                              videos: content.videos,
                              videoMap: videoMap
                            }"
                            style="font-weight: 500"
                          ></app-multi-data>
                        </div>
                      </div>
                    </div>
                    <!-- Preview for Options -->
                    <div>
                      <div
                        class="create-module__right__preview__body__item__item"
                      >
                        <!-- <span class="create-module__dialog__body__item__item--title"
                      >Answers
                    </span> -->
                        <!-- <ng-container *ngFor="let optionArray of question.choices"> -->
                        <ng-container
                          *ngIf="question.question.questionType === 1"
                        >
                          <div
                            *ngFor="
                              let option of question.choices;
                              let optionIndex = index
                            "
                            class="create-module__right__preview__body__item__item__option"
                            [ngClass]="{
                              'create-module__right__preview__body__item__item__option--correct':
                                option.isAnswer
                            }"
                          >
                            <span
                              class="create-module__right__preview__body__item__item__option--label"
                              >{{ optionsText[optionIndex] }})</span
                            >
                            <div>
                              <div
                                *ngFor="
                                  let content of option.optionValue;
                                  let optionValueIndex = index
                                "
                              >
                                <app-multi-data
                                  [multiData]="{
                                    type: content.type,
                                    data: content.data,
                                    tikzId:
                                      'learningModule-tikz-' +
                                      optionValueIndex +
                                      '-' +
                                      optionIndex +
                                      '-' +
                                      questionIndex +
                                      '-' +
                                      index,
                                    imageKeys: content.images,
                                    listOfImages: images,
                                    videos: content.videos,
                                    videoMap: videoMap
                                  }"
                                ></app-multi-data>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <!-- </ng-container> -->
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="question.question.questionType === 1">
                    <ng-container
                      *ngFor="
                        let option of question.choices;
                        let optionIndex = index
                      "
                    >
                      <ng-container *ngIf="option.isAnswer">
                        <div
                          class="learning-modules-container__mt-20 create-module__right__preview__question"
                        >
                          Answer
                        </div>
                        <div class="flex items-center gap-2">
                          <div>{{ optionsText[optionIndex] }})</div>
                          <div class="flex flex-col gap-4">
                            <div
                              *ngFor="
                                let optionValue of option.optionValue;
                                let optionValueIndex = index
                              "
                            >
                              <app-multi-data
                                [multiData]="{
                                  type: optionValue.type,
                                  data: optionValue.data,
                                  tikzId:
                                    'learningModule-tikz-answer-' +
                                    optionValueIndex +
                                    '-' +
                                    optionIndex +
                                    '-' +
                                    questionIndex +
                                    '-' +
                                    index,
                                  imageKeys: optionValue.images,
                                  listOfImages: images,
                                  videos: optionValue.videos || [],
                                  videoMap: videoMap
                                }"
                              ></app-multi-data>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-container
                      *ngFor="
                        let option of question.choices;
                        let optionIndex = index
                      "
                    >
                      <ng-container *ngIf="option.explanation?.length > 0">
                        <div
                          class="learning-modules-container__mt-20 create-module__right__preview__question"
                        >
                          Option {{ optionsText[optionIndex] }} Explanation
                        </div>
                        <div
                          *ngFor="
                            let explanation of option.explanation;
                            let explanationIndex = index
                          "
                        >
                          <app-multi-data
                            [multiData]="{
                              type: explanation.type,
                              data: explanation.data,
                              tikzId:
                                'learningModule-tikz-explanation-' +
                                explanationIndex +
                                '-' +
                                optionIndex +
                                '-' +
                                questionIndex +
                                '-' +
                                index,
                              imageKeys: explanation.images,
                              listOfImages: images,
                              videos: explanation.videos || [],
                              videoMap: videoMap
                            }"
                          ></app-multi-data>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="question.question.questionType === 2">
                    <div
                      class="learning-modules-container__mt-20 create-module__right__preview__question"
                    >
                      Answer(s)
                    </div>
                    <ng-container
                      *ngFor="
                        let posibility of question.answers.posibilities;
                        let posibilityIndex = index
                      "
                    >
                      {{
                        posibility +
                          (posibilityIndex + 1 ===
                          question.answers.posibilities?.length
                            ? ""
                            : ",")
                      }}
                    </ng-container>
                    <div
                      class="learning-modules-container__mt-20 create-module__right__preview__question"
                      *ngIf="question.answers.explanation?.length > 0"
                    >
                      Answer Explanation
                    </div>
                    <ng-container
                      *ngFor="
                        let explanation of question.answers.explanation;
                        let explanationIndex = index
                      "
                    >
                      <app-multi-data
                        [multiData]="{
                          type: explanation.type,
                          data: explanation.data,
                          tikzId:
                            'learningModule-tikz-explanation-' +
                            explanationIndex +
                            '-' +
                            questionIndex +
                            '-' +
                            index,
                          imageKeys: explanation.images,
                          listOfImages: images,
                          videos: explanation.videos || [],
                          videoMap: videoMap
                        }"
                      ></app-multi-data>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="question.videos?.length > 0">
                    <app-multi-data
                      [multiData]="{
                        type: 'Videos',
                        data: question.videos,
                        tikzId: '',
                        imageKeys: [],
                        listOfImages: images,
                        videos: question.videos,
                        videoMap: questionVideoMap
                      }"
                    ></app-multi-data>
                  </ng-container>
                </div>
              </ng-container>
            </div>
            <ng-container
              *ngIf="
                data.panelType.display === 'Exercise (Enter Manually)' &&
                data.questions!.length !== 0
              "
            >
              <ng-container
                *ngFor="
                  let question of data.questions;
                  let questionIndex = index
                "
              >
                <span
                  class="learning-modules-container__mt-20 create-module__right__preview__question"
                  >Question {{ questionIndex + 1 }}</span
                >
                <span
                  *ngFor="
                    let questionItem of question.question;
                    let editIndex = index
                  "
                  class="learning-modules-container__mt-20"
                >
                  <app-multi-data
                    [multiData]="{
                      type: questionItem.type,
                      data: questionItem.data,
                      tikzId:
                        'learningModule-tikz-' +
                        editIndex +
                        '-' +
                        questionIndex +
                        '-' +
                        index,
                      imageKeys: questionItem.images,
                      listOfImages: images,
                      videos: questionItem.videos || [],
                      videoMap: videoMap
                    }"
                  ></app-multi-data>
                </span>
                <span
                  class="learning-modules-container__mt-20 create-module__right__preview__question"
                  >Answer</span
                >
                <span class="learning-modules-container__mt-20">
                  <app-multi-data
                    [multiData]="{
                      type: question.answer.type,
                      data: question.answer.data,
                      tikzId: '',
                      imageKeys: question.images,
                      listOfImages: images,
                      videos: question.answer.videos || [],
                      videoMap: videoMap
                    }"
                  ></app-multi-data>
                </span>
                <hr class="learning-modules-container__mt-20" />
              </ng-container>
            </ng-container>
            <span
              *ngFor="let editData of data.content; let editIndex = index"
              class="learning-modules-container__pt-20"
            >
              <app-multi-data
                [multiData]="{
                  type: editData.type,
                  data: editData.data,
                  tikzId: 'learningModule-tikz-' + editIndex + '-' + index,
                  imageKeys: editData.images || [],
                  listOfImages: images,
                  videos: editData.videos || [],
                  videoMap: videoMap
                }"
                *ngIf="editData.type !== 'Images'"
              ></app-multi-data>
              <ng-container *ngIf="editData.type === 'Images'">
                <img
                  *ngFor="let image of editData.images"
                  [src]="images[image]"
                  class="create-module__right__preview__image"
                />
              </ng-container>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-overlayPanel #overlay [dismissable]="true">
  <div class="create-module__overlay">
    <ng-container
      *ngIf="
        overlayType === 'code' ||
        overlayType === 'question' ||
        overlayType === panelStrings.ADDITIONAL
      "
    >
      <span
        *ngFor="let codeType of codeTypes"
        class="create-module__overlay__options"
        (click)="addPanelContent(codeType.type, overlay)"
        >{{ codeType.display }}</span
      >
      <!-- <span
        *ngIf="editorArray[selectedPanel!].panelType.display === 'Exercise'"
        class="create-module__overlay__options"
        (click)="showDialog = true"
        >Select a question to add</span
      > -->
    </ng-container>

    <ng-container *ngIf="overlayType === 'panel'">
      <span
        *ngFor="let panelType of panelTypes"
        class="create-module__overlay__options"
        (click)="addPanel(panelType, overlay)"
        >{{ panelType.display }}</span
      >
    </ng-container>
  </div>
</p-overlayPanel>

<p-confirmDialog
  acceptButtonStyleClass="create-question__confirm__button"
  rejectButtonStyleClass="create-question__confirm__button"
  [style]="{ width: '25vw' }"
  styleClass="create-question__confirm"
>
  Content
</p-confirmDialog>

<p-dialog
  [(visible)]="showDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  class="create-module__my-dialog"
>
  <div class="create-module__dialog">
    <div class="create-module__dialog__head">
      <span class="create-module__dialog__head__text"
        >Select questions to add</span
      >
      <div class="create-module__dialog__head__courses">
        <ng-container>
          <div class="create-module__dialog__head__courses__course">
            <mat-label
              class="create-module__dialog__head__courses__course--label"
              >Course</mat-label
            >
            <mat-select
              [(ngModel)]="dialogSelectedCourse"
              (selectionChange)="selectCourse('dialog')"
            >
              <mat-option
                *ngFor="let course of courses"
                [value]="course.testTypeId"
                >{{ course.testTypeName }}</mat-option
              >
            </mat-select>
          </div>
          <div class="create-module__dialog__head__courses__course">
            <mat-label
              class="create-module__dialog__head__courses__course--label"
              >Section</mat-label
            >
            <mat-select
              [(ngModel)]="dialogSelectedSection"
              (selectionChange)="selectSection('dialog')"
            >
              <mat-option
                *ngFor="let section of dialogSections"
                [value]="section.test_section_type_id"
                >{{ section.test_section }}</mat-option
              >
            </mat-select>
          </div>

          <div class="create-module__dialog__head__courses__course">
            <mat-label
              class="create-module__dialog__head__courses__course--label"
              >Topic</mat-label
            >
            <mat-select
              [(ngModel)]="dialogSelectedTopic"
              (selectionChange)="selectTopic('dialog')"
            >
              <mat-option
                *ngFor="let topic of dialogTopics; let topicIndex = index"
                [value]="topic.topic_id"
                >{{ topic.topic_name }}</mat-option
              >
            </mat-select>
          </div>
          <div
            class="create-module__dialog__head__courses__course"
            style="padding-bottom: 10px"
          >
            <mat-label
              class="create-module__dialog__head__courses__course--label"
              >Sub-Topic</mat-label
            >
            <mat-select
              [(ngModel)]="dialogSelectedSubTopic"
              (selectionChange)="getQuestionsWithParams()"
            >
              <mat-option
                *ngFor="
                  let subTopic of dialogSubTopics;
                  let subTopicIndex = index
                "
                [value]="subTopic.subtopic_id"
                >{{ subTopic.subtopic_name }}</mat-option
              >
            </mat-select>
          </div>
          <div
            class="create-module__dialog__head__courses__course"
            style="padding-bottom: 10px; position: relative; min-height: 65px"
          >
            <!-- Spinner overlay -->
            <div
              *ngIf="loading"
              style="
                position: absolute;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgba(255, 255, 255, 0.6);
                z-index: 10;
              "
            >
              <mat-spinner diameter="30"></mat-spinner>
            </div>

            <mat-label
              class="create-module__dialog__head__courses__course--label"
            >
              Question Category
            </mat-label>

            <mat-select
              [(ngModel)]="selectedQuestionCategory"
              (selectionChange)="getQuestionsWithParams()"
              [disabled]="loading"
            >
              <mat-option [value]="0">All</mat-option>
              <mat-option
                *ngFor="
                  let category of questionCategories;
                  let categoryIndex = index
                "
                [value]="categoryIndex + 1"
              >
                {{ category.label }}
              </mat-option>
            </mat-select>
          </div>

          <div
            class="create-module__dialog__head__courses__course"
            style="padding-bottom: 10px"
          >
            <mat-label
              class="create-module__dialog__head__courses__course--label"
            >
              Question Level
            </mat-label>
            <mat-select
              [(ngModel)]="selectedQuestionLevel"
              (selectionChange)="getQuestionsWithParams()"
            >
              <mat-option [value]="0">All</mat-option>
              <mat-option [value]="1">Easy</mat-option>
              <mat-option [value]="2">Medium</mat-option>
              <mat-option [value]="3">Hard</mat-option>
            </mat-select>
          </div>
        </ng-container>
      </div>
    </div>
    <div
      *ngFor="let question of questions; let questionIndex = index"
      class="create-module__dialog__body"
      [ngClass]="{
        'create-module__dialog__body--grid':
          question.question.displayStyle === 2
      }"
    >
      <!-- <p-checkbox
        [binary]="true"
        [value]="question.question.questionId"
        (onChange)="checkBoxEvent($event, question.question.questionId)"
      ></p-checkbox> -->
      <p-checkbox [(ngModel)]="question.selected" [binary]="true"></p-checkbox>
      <div class="create-module__dialog__body__item">
        <div class="create-module__dialog__body__item__item">
          <!-- <span class="create-module__dialog__body__item__item--title"
            >Question {{ questionIndex + 1 }}</span
          > -->
          <div
            *ngFor="
              let content of question.question.questionData;
              let questionDataIndex = index
            "
            [ngClass]="{
              'create-module__dialog__body__item__item--tikz':
                content.type === 'TikZ'
            }"
          >
            <app-multi-data
              [multiData]="{
                type: content.type,
                data: content.data,
                tikzId: 'tikzOutput-' + questionIndex + '-' + questionDataIndex,
                imageKeys: content.images,
                listOfImages: images,
                videos: content.videos,
                videoMap: videoMap
              }"
              style="font-weight: 500"
            ></app-multi-data>
          </div>
        </div>
        <!-- Preview for Options -->
        <div class="create-module__dialog__body__item__item">
          <!-- <span class="create-module__dialog__body__item__item--title"
            >Answers
          </span> -->
          <!-- <ng-container *ngFor="let optionArray of question.choices"> -->
          <ng-container *ngIf="question.question.questionType === 1">
            <div
              *ngFor="let option of question.choices; let optionIndex = index"
              class="create-module__dialog__body__item__item__option"
              [ngClass]="{
                'create-module__dialog__body__item__item__option--correct':
                  option.isAnswer
              }"
            >
              <span
                class="create-module__dialog__body__item__item__option--label"
                >{{ optionsText[optionIndex] }})</span
              >
              <div>
                <div
                  *ngFor="let content of option.optionValue; let index = index"
                >
                  <app-multi-data
                    [multiData]="{
                      type: content.type,
                      data: content.data,
                      tikzId:
                        'tikzOutput-option-' +
                        questionIndex +
                        '-' +
                        optionIndex +
                        '-' +
                        index,
                      imageKeys: content.images,
                      listOfImages: images,
                      videos: content.videos,
                      videoMap: videoMap
                    }"
                  ></app-multi-data>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="question.question.questionType === 2">
            <div
              class="create-module__dialog__body__item__item__option create-module__dialog__body__item__option--correct"
            >
              <div
                *ngFor="
                  let answer of question.answers.posibilities;
                  let answerIndex = index
                "
              >
                {{
                  answer +
                    (answerIndex < question.answers.posibilities.length - 1
                      ? ","
                      : "")
                }}&nbsp;
              </div>
            </div>
          </ng-container>
          <!-- </ng-container> -->
        </div>
      </div>
    </div>
    <div class="create-module__dialog__buttons">
      <button
        class="create-module__dialog__add-btn"
        *ngIf="displaySelectAll(true)"
        (click)="toggleAllQuestions(true)"
      >
        Select All
      </button>
      <button
        class="create-module__dialog__add-btn"
        *ngIf="displaySelectAll(false)"
        (click)="toggleAllQuestions(false)"
      >
        Unselect All
      </button>
      <button
        class="create-module__dialog__add-btn"
        (click)="addSelectedQuestionId()"
      >
        Add
      </button>
    </div>
  </div>
</p-dialog>

<!-- <div id="watermark">Ravi's Academy</div> -->
